import React from "react"
import {useTranslation} from "react-i18next"
import CommonUtils from "@bodeboca/utils"

const Tags = ({hit}) => {
  const {t} = useTranslation()
  const tagColours = CommonUtils.getTagColours()
  const languageInfo = hit[CommonUtils.getCurrentLanguage()] !== undefined ? hit[CommonUtils.getCurrentLanguage()] : hit['es']
  let tags = (languageInfo["special_status_tags"] && languageInfo["special_status_tags"].length > 0)
    ? languageInfo["special_status_tags"]
    : languageInfo["json_tags"]

  if (tags === null || tags === undefined) {
    tags = []
  }
  tags = Object.values(tags)

  let newFormat = false
  if (tags[0] !== undefined) {
    if (tags[0]['colour'] !== undefined) {
      newFormat = true
    }
  }

  return (<div>
    {tags.length > 0 && <div className="special-status">
      {newFormat && tags.map((tag, index) => (<div
        className={"tag tag-newformat tag-" + tag.colour + " " + tag.class}
        key={index}>
        {tag.text}
      </div>))}
      {!newFormat && tags.map((tag, index) => (<div
        className={"tag tag-oldformat tag-" + tagColours[tag.key] + " " + tag.key}
        key={index}>
        {t(tag.label)}
      </div>))}
    </div>}
  </div>)
}
export default Tags
